import { render } from "./volume-based-price-list-container.vue?vue&type=template&id=1410a866&scoped=true"
import script from "./volume-based-price-list-container.vue?vue&type=script&lang=js"
export * from "./volume-based-price-list-container.vue?vue&type=script&lang=js"

import "./volume-based-price-list-container.vue?vue&type=style&index=0&id=1410a866&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1410a866"]])

export default __exports__